import React from 'react';

import { Branding, useBrandingData } from '../dataProviders';
import ThemeProvider, { ThemeConfigOverrides } from '../Theme';
import PoweredBy from '../components/PoweredBy';
import { makeBtStyles } from '../Theme';

import AppBar from './AppBar';


import TrackingPage from './TrackingPage';
import ReturnsPage from './ReturnsPage';
import { Hidden } from '@material-ui/core';


const useStyles = makeBtStyles( theme => ({
  layout02: {
    position: 'relative', // want 'absolute'-ly positioned elements to be able to go below the fold (body => height:100%)
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flexGrow: '1',
    display: 'flex'
  }
}));

function Layout02({ children }:{
  branding: Branding,
  children: React.ReactNode
}) {
  const branding = useBrandingData();
  const { colors } = branding;
  const classes = useStyles();

  const themeOverrides : ThemeConfigOverrides = colors ? {
    page: { background: colors.secondary },
    link: { color: colors.tertiary },
    colors: { main: colors.primary },
    layoutSpecific: {
      layout02: {
        recentTrackingDot: { backgroundColor: colors.tertiary }
      }
    }
  } : {};

  return (
    <ThemeProvider configOverrides={themeOverrides}>
      <div data-testid="layout02" className={classes.layout02}>
        <Hidden lgUp>
          <AppBar /> 
        </Hidden>
        <div className={classes.content}>
          {children}
        </div>
        <PoweredBy />
      </div>
    </ThemeProvider>
  );
}

export default {
  Layout: Layout02,
  TrackingPage,
  ReturnsPage
};